// Generated from OpenStreetMap (Overpass API): all Slovak municipalities
// with town/city status (place=city|town), July 2026. Keys are ascii
// lowercase dash slugs of the town name; values are [longitude, latitude].
// Regenerate with an Overpass query on area SK if the town list changes.
export const SLOVAK_CITY_CENTERS: Record<string, [number, number]> = {
  'banovce-nad-bebravou': [18.2598, 48.7217], // Bánovce nad Bebravou
  'banska-bystrica': [19.1457, 48.7354], // Banská Bystrica
  'banska-stiavnica': [18.8988, 48.4581], // Banská Štiavnica
  'bardejov': [21.2756, 49.2927], // Bardejov
  'bojnice': [18.5822, 48.78], // Bojnice
  'bratislava': [17.1093, 48.1517], // Bratislava
  'brezno': [19.641, 48.8053], // Brezno
  'brezova-pod-bradlom': [17.537, 48.6616], // Brezová pod Bradlom
  'bytca': [18.5587, 49.2236], // Bytča
  'cadca': [18.7896, 49.4375], // Čadca
  'cierna-nad-tisou': [22.0887, 48.4166], // Čierna nad Tisou
  'detva': [19.4206, 48.5596], // Detva
  'dobsina': [20.3649, 48.8211], // Dobšiná
  'dolny-kubin': [19.2953, 49.2145], // Dolný Kubín
  'dubnica-nad-vahom': [18.1663, 48.9574], // Dubnica nad Váhom
  'dudince': [18.8823, 48.1692], // Dudince
  'dunajska-streda': [17.6163, 47.9956], // Dunajská Streda
  'filakovo': [19.8223, 48.2702], // Fiľakovo
  'gabcikovo': [17.5781, 47.8951], // Gabčíkovo
  'galanta': [17.7271, 48.191], // Galanta
  'gbely': [17.1158, 48.7182], // Gbely
  'gelnica': [20.9378, 48.8534], // Gelnica
  'giraltovce': [21.5167, 49.1135], // Giraltovce
  'handlova': [18.7627, 48.7314], // Handlová
  'hanusovce-nad-toplou': [21.5022, 49.0269], // Hanušovce nad Topľou
  'hlohovec': [17.7988, 48.4279], // Hlohovec
  'hnusta': [19.9534, 48.5785], // Hnúšťa
  'holic': [17.1621, 48.8079], // Holíč
  'hrinova': [19.5259, 48.5765], // Hriňová
  'humenne': [21.902, 48.935], // Humenné
  'hurbanovo': [18.1983, 47.8761], // Hurbanovo
  'ilava': [18.2308, 48.9986], // Ilava
  'jelsava': [20.241, 48.6275], // Jelšava
  'kezmarok': [20.4309, 49.1362], // Kežmarok
  'kolarovo': [17.9967, 47.9182], // Kolárovo
  'komarno': [18.1298, 47.7574], // Komárno
  'kosice': [21.2497, 48.7172], // Košice
  'kralovsky-chlmec': [21.9805, 48.4224], // Kráľovský Chlmec
  'krasno-nad-kysucou': [18.8322, 49.3897], // Krásno nad Kysucou
  'kremnica': [18.9175, 48.7042], // Kremnica
  'krompachy': [20.8755, 48.9144], // Krompachy
  'krupina': [19.0692, 48.3527], // Krupina
  'kysucke-nove-mesto': [18.7865, 49.2999], // Kysucké Nové Mesto
  'leopoldov': [17.7654, 48.4442], // Leopoldov
  'levice': [18.6001, 48.2163], // Levice
  'levoca': [20.5887, 49.0251], // Levoča
  'lipany': [20.9641, 49.1525], // Lipany
  'liptovsky-hradok': [19.7217, 49.0372], // Liptovský Hrádok
  'liptovsky-mikulas': [19.6128, 49.0836], // Liptovský Mikuláš
  'lucenec': [19.6634, 48.3304], // Lučenec
  'malacky': [17.02, 48.4363], // Malacky
  'martin': [18.9292, 49.0725], // Martin
  'medzev': [20.8923, 48.7003], // Medzev
  'medzilaborce': [21.904, 49.2711], // Medzilaborce
  'michalovce': [21.9212, 48.7514], // Michalovce
  'modra': [17.3088, 48.3357], // Modra
  'modry-kamen': [19.3341, 48.2406], // Modrý Kameň
  'moldava-nad-bodvou': [20.9973, 48.6141], // Moldava nad Bodvou
  'myjava': [17.565, 48.754], // Myjava
  'namestovo': [19.4804, 49.4095], // Námestovo
  'nemsova': [18.1176, 48.9646], // Nemšová
  'nesvady': [18.1286, 47.9285], // Nesvady
  'nitra': [18.0895, 48.313], // Nitra
  'nova-bana': [18.6414, 48.4246], // Nová Baňa
  'nova-dubnica': [18.1457, 48.9359], // Nová Dubnica
  'novaky': [18.5408, 48.7164], // Nováky
  'nove-mesto-nad-vahom': [17.8304, 48.7633], // Nové Mesto nad Váhom
  'nove-zamky': [18.1631, 47.9862], // Nové Zámky
  'partizanske': [18.3718, 48.6265], // Partizánske
  'pezinok': [17.2702, 48.2855], // Pezinok
  'piestany': [17.8214, 48.5895], // Piešťany
  'podolinec': [20.5338, 49.2571], // Podolínec
  'poltar': [19.7924, 48.4308], // Poltár
  'poprad': [20.2976, 49.0542], // Poprad
  'povazska-bystrica': [18.447, 49.1159], // Považská Bystrica
  'presov': [21.2392, 49.0], // Prešov
  'prievidza': [18.6235, 48.7718], // Prievidza
  'puchov': [18.324, 49.1239], // Púchov
  'rajec': [18.6352, 49.0886], // Rajec
  'rajecke-teplice': [18.6829, 49.1275], // Rajecké Teplice
  'revuca': [20.1167, 48.6833], // Revúca
  'rimavska-sobota': [20.0181, 48.3834], // Rimavská Sobota
  'roznava': [20.5329, 48.6621], // Rožňava
  'ruzomberok': [19.3034, 49.0816], // Ružomberok
  'sabinov': [21.0973, 49.1027], // Sabinov
  'sahy': [18.9483, 48.0693], // Šahy
  'sala': [17.8749, 48.1514], // Šaľa
  'samorin': [17.3116, 48.0276], // Šamorín
  'sastin-straze': [17.1439, 48.638], // Šaštín-Stráže
  'secovce': [21.6556, 48.7015], // Sečovce
  'senec': [17.397, 48.2199], // Senec
  'senica': [17.3662, 48.6788], // Senica
  'sered': [17.7309, 48.2889], // Sereď
  'skalica': [17.2288, 48.8461], // Skalica
  'sladkovicovo': [17.644, 48.2053], // Sládkovičovo
  'sliac': [19.1424, 48.6132], // Sliač
  'snina': [22.1556, 48.9901], // Snina
  'sobrance': [22.1807, 48.7447], // Sobrance
  'spisska-bela': [20.4545, 49.1893], // Spišská Belá
  'spisska-nova-ves': [20.563, 48.9435], // Spišská Nová Ves
  'spisska-stara-ves': [20.3598, 49.3831], // Spišská Stará Ves
  'spisske-podhradie': [20.7511, 49.0], // Spišské Podhradie
  'spisske-vlachy': [20.7974, 48.9466], // Spišské Vlachy
  'stara-lubovna': [20.6889, 49.3002], // Stará Ľubovňa
  'stara-tura': [17.6949, 48.7782], // Stará Turá
  'strazske': [21.8338, 48.8747], // Strážske
  'stropkov': [21.6521, 49.202], // Stropkov
  'stupava': [17.033, 48.273], // Stupava
  'sturovo': [18.7159, 47.7978], // Štúrovo
  'surany': [18.1868, 48.0861], // Šurany
  'svaty-jur': [17.2127, 48.2542], // Svätý Jur
  'svidnik': [21.5734, 49.3085], // Svidník
  'svit': [20.1965, 49.0582], // Svit
  'tisovec': [19.9421, 48.6813], // Tisovec
  'tlmace': [18.5311, 48.2897], // Tlmače
  'topolcany': [18.1754, 48.5594], // Topoľčany
  'tornala': [20.3233, 48.4222], // Tornaľa
  'trebisov': [21.7202, 48.6286], // Trebišov
  'trencianske-teplice': [18.1703, 48.9094], // Trenčianske Teplice
  'trencin': [18.0387, 48.8923], // Trenčín
  'trnava': [17.5858, 48.3768], // Trnava
  'trstena': [19.6086, 49.3592], // Trstená
  'turany': [19.0392, 49.1164], // Turany
  'turcianske-teplice': [18.8608, 48.8614], // Turčianske Teplice
  'turzovka': [18.6263, 49.4051], // Turzovka
  'tvrdosin': [19.5554, 49.3341], // Tvrdošín
  'velke-kapusany': [22.0774, 48.5539], // Veľké Kapušany
  'velky-krtis': [19.349, 48.2093], // Veľký Krtíš
  'velky-meder': [17.7694, 47.8558], // Veľký Meder
  'velky-saris': [21.1973, 49.0406], // Veľký Šariš
  'vrable': [18.3061, 48.2443], // Vráble
  'vranov-nad-toplou': [21.6822, 48.8892], // Vranov nad Topľou
  'vrbove': [17.7239, 48.6195], // Vrbové
  'vrutky': [18.9251, 49.1089], // Vrútky
  'vysoke-tatry': [20.2167, 49.1355], // Vysoké Tatry
  'zarnovica': [18.7215, 48.4834], // Žarnovica
  'zeliezovce': [18.6584, 48.0492], // Želiezovce
  'ziar-nad-hronom': [18.8501, 48.591], // Žiar nad Hronom
  'zilina': [18.7393, 49.2235], // Žilina
  'zlate-moravce': [18.4, 48.3833], // Zlaté Moravce
  'zvolen': [19.1247, 48.5783], // Zvolen
}
